const uz = {
    translation: {
            title: "Yuk mashinalari",
            intro: {
              main_text: "Muvaffaqiyatingiz kafolati",
              text_1: "MMSH Logistics kompaniyasida biz butun dunyo bo‘ylab ishonchli va samarali avtomobil yuk tashish xizmatlariga talab yuqori ekanligini tushunamiz. Bizning yuk mashinalarimiz orqali yuk tashish xizmatlarimiz port, aeroport yoki temir yo‘l stansiyalaridan mustaqil holda, moslashuvchan jadval asosida amalga oshiriladi. Maxsus yechim yaratish va eng yaxshi yo‘nalishni tuzishdan oldin, bizning tajribali logistika jamoamiz har bir so‘rovni diqqat bilan tahlil qiladi. Mijozlarimizning vaqtini qadrlagan holda, biz yuklarni kuzatish uchun so‘nggi GPS va GLONASS texnologiyalaridan foydalanamiz."
            },
          
            more_info: "Batafsil ma’lumot",
          
            projects: {
              title: "Tugallangan loyihalar",
              items: [
                { title: "Global haydovchi yetishmovchiligi." },
                { title: "Sizga yordam beradigan raqamli yechimlar." },
                { title: "Yangi dengiz tashish yo‘nalishlari." },
                { title: "Turkiya zilzilalarining ta’siri." }
              ]
            },
          
            completed_projects: {
              title: "TUGALLANGAN LOYIHALAR",
              items: [
                { title: "Yangi port sizga xizmat ko‘rsatishga tayyor." },
                { title: "Biznes kafolati." },
                { title: "Bizning kemalarimiz AQSh bilan ishlay boshladi." }
              ]
            },
          
            title_2: "Poyezdlar",
            intro_2: {
              main_text_2: "Temiryo‘l yuk tashish bilan tez yetkazib berish",
              text_1: "MMSH Logistics kompaniyasi sifatida biz tezkor, iqtisodiy va ekologik toza temir yo‘l yuk tashish xizmatlariga bo‘lgan talab ortib borayotganini tushunamiz. Bizning temir yo‘l transport xizmatlarimiz keng miqyosdagi yuk tashish imkoniyatini taqdim etib, uzoq masofalarda samaradorlik va barqarorlikni ta’minlaydi. Shaxsiy logistika rejasini tuzishdan oldin, bizning mutaxassis jamoamiz har bir so‘rovni diqqat bilan tahlil qilib, yo‘nalishlarni maksimal tezlik va tejash uchun optimallashtiradi. GPS va GLONASS kabi ilg‘or kuzatuv texnologiyalaridan foydalangan holda, biz real vaqt rejimida yuk jo‘natmalari ko‘rinishini ta’minlaymiz, bu esa mijozlarimizga har bir kilometrda ishonch bag‘ishlaydi."
            },
          
            projects_2: {
              title: "Tugallangan loyihalar",
              items: [
                { title: "Xizmatlarimizning raqamlashtirilishi." },
                { title: "Yevropa bilan ko‘proq savdo." },
                { title: "Yaponiyadan yangi poyezdlar tayyor." },
                { title: "Xodimlarimiz uchun ish haqi o‘sishi." }
              ]
            },
          
            completed_projects_2: {
              title: "TUGALLANGAN LOYIHALAR",
              items: [
                { title: "Ohaio shtatida yangi ofisimiz ochildi." },
                { title: "Endi yuk tashish tezroq." },
                { title: "Pekin bilan savdo aloqalarimiz mustahkamlanmoqda." },
                { title: "Yangi logistika ilovamizdan foydalaning." }
              ]
            },
          
            title_3: "Havo transporti",
            intro_3: {
              main_text_3: "Tez va ishonchli havo yuk tashish yechimlari",
              text_1: "Xalqaro tashuvchilar tarmog‘iga ega bo‘lib, biz moslashuvchan jadval, ustuvor yuk tashish va har qanday biznes uchun moslashtirilgan logistika yechimlarini taklif etamiz. Agar yuk shoshilinch, qimmatbaho yoki haroratga sezgir bo‘lsa, biz uni eng yuqori xavfsizlik va g‘amxo‘rlik bilan yetkazib beramiz. GPS va ilg‘or logistika tizimlari kabi real vaqt rejimida kuzatuv texnologiyalarini birlashtirib, biz jo‘natmalarni jo‘natishdan kelish joyigacha to‘liq nazorat qilish imkonini taqdim etamiz. Tajribali jamoamiz yo‘nalishlarni maksimal samaradorlik va tejamkorlik uchun optimallashtiradi, bu esa mukammal havo yuk tashish tajribasini yaratadi. MMSH Logistics bilan dunyo sizning qo‘lingizda. Tezlik muhim bo‘lganda, biz yetkazib beramiz."
            },
          
            projects_3: {
              title: "Tugallangan loyihalar",
              items: [
                { title: "MMSH bilan ishonchli hamkorlik." },
                { title: "Boshqa qit’alarga eng tez yetkazib berish." },
                { title: "Arzon va tezkor havo transporti." }
              ]
            },
          
            completed_projects_3: {
              title: "TUGALLANGAN LOYIHALAR",
              items: [
                { title: "Xalqaro kompaniyalar bilan hamkorlik." },
                { title: "Janubiy Amerika bilan ish boshladik." }
              ]
            },
          
            title_4: "Dengiz transporti",
            intro_4: {
              main_text_4: "Uzluksiz va ishonchli dengiz yuk tashish yechimlari",
              text_1: "Bizning keng global tashish tarmog‘imiz orqali biznesingiz uchun moslashuvchan jadval, xavfsiz boshqaruv va moslashtirilgan logistika yechimlarini taqdim etamiz. Agar sizga ommaviy yuk, katta o‘lchamli uskunalar yoki haroratga sezgir yuk kerak bo‘lsa, biz uni xalqaro suvlar orqali xavfsiz va samarali tashishni kafolatlaymiz. GPS, AIS (Avtomatik Identifikatsiya Tizimi) va sun’iy yo‘ldosh kuzatuvi kabi ilg‘or kuzatuv texnologiyalaridan foydalangan holda, biz yuk jo‘natmalarining portdan portgacha real vaqt rejimida kuzatilishini ta’minlaymiz."
            },
          
            projects_4: {
              title: "Tugallangan loyihalar",
              items: [
                { title: "Savdo uchun yangi portlar ochildi." },
                { title: "Yaxshi tartibga solingan xavfsizlik dasturlari." },
                { title: "Dengiz orqali qulay tashish." }
              ]
            },
          
            completed_projects_4: {
              title: "TUGALLANGAN LOYIHALAR",
              items: [
                { title: "Gonkong porti bilan hamkorlik o‘rnatildi." },
                { title: "MMSH bilan tezkor transport." }
              ]
            },          
                // Multimodal
                title_5: "Multimodal",
                intro_5: {
                  main_text_5: "Integratsiyalangan va samarali multimodal yuk tashish yechimlari",
                  text_1: "Havo, dengiz, avtomobil va temir yo‘l transportining kuchlarini birlashtirib, biz sizning biznes ehtiyojlaringizga mos keladigan uzluksiz multimodal logistika yechimlarini taqdim etamiz. Bizning moslashuvchan jadval va xavfsiz boshqaruv usullarimiz tovarlarning chegaralar va qit’alar bo‘ylab samarali harakatlanishini ta’minlaydi. Konteynerlangan yuklar, katta o‘lchamli uskunalar yoki haroratga sezgir jo‘natmalar bo‘ladimi, biz tranzit vaqtlarini qisqartirish va xarajatlarni kamaytirish uchun yo‘nalishlarni optimallashtiramiz. Ilg‘or kuzatuv texnologiyalari, jumladan GPS, AIS va sun’iy yo‘ldosh monitoringi yordamida, biz sayohatning har bir bosqichida real vaqt rejimida ko‘rinish taqdim etamiz. Bizning mutaxassis jamoamiz transport turlari o‘rtasida muvofiqlashtirilgan logistika bilan tezkor va tejamkor yetkazib berishni ta’minlaydi."
                },
              
                projects_5: {
                  title: "Tugallangan loyihalar",
                  items: [
                    { title: "Global savdo yo‘nalishlarining kengaytirilishi." },
                    { title: "AI boshqaruv tizimlarining joriy etilishi." },
                    { title: "Multimodal yuk tashish yechimlarini optimallashtirish." },
                    { title: "Barqaror yuk tashish amaliyotlarini rivojlantirish." }
                  ]
                },
              
                completed_projects_5: {
                  title: "TUGALLANGAN LOYIHALAR",
                  items: [
                    { title: "Gonkong porti bilan strategik hamkorlik." },
                    { title: "MMSH Express xizmati bilan tezkor logistika." }
                  ]
                },
                // Multimodal
              
                // Chemicals
                title_6: "Kimyoviy moddalar",
                intro_6: {
                  main_text_6: "Xavfsiz, samarali va reglamentga mos kimyo logistikalari",
                  text_1: "MMSH Logistics kimyoviy yuklarni xavfsiz va samarali tashish bo‘yicha mutaxassis bo‘lib, xalqaro xavfsizlik qoidalariga to‘liq mosligini ta’minlaydi. Bizning multimodal transport yechimlarimiz—avtomobil, dengiz, temir yo‘l va havo transportini qamrab olgan holda—xavfli va xavfsiz kimyoviy moddalarning uzluksiz tashilishini kafolatlaydi. Biz yetakchi sanoat kompaniyalari bilan hamkorlikda xavfsiz muomala qilish, haroratni boshqarish va maxsus transport usullarini taqdim etamiz. Bizning tajribali jamoamiz barcha zarur hujjatlar va muvofiqlik talablarini boshqaradi, bojxona tartibotlarini soddalashtirib, xalqaro bozor talablariga javob berishni ta’minlaydi. Ilg‘or kuzatuv texnologiyalaridan foydalangan holda, biz butun ta’minot zanjiri davomida to‘liq ko‘rinishni taqdim etamiz, bu esa kimyo logistikasi uchun ishonchli va tejamkor yechimni yaratadi."
                },
              
                projects_6: {
                  title: "Kimyoviy yuk tashish yechimlaridagi ilg‘or texnologiyalar",
                  items: [
                    { title: "Kimyoviy transport yo‘nalishlarining global kengaytirilishi." },
                    { title: "Xavfli materiallarni kuzatish uchun AI tizimlari." },
                    { title: "Kimyoviy moddalar uchun optimallashtirilgan multimodal logistika." },
                    { title: "Kimyo yuk tashish uchun ekologik toza yechimlar." }
                  ]
                },
              
                completed_projects_6: {
                  title: "TUGALLANGAN LOYIHALAR",
                  items: [
                    { title: "Yevropada yangi kimyoviy logistika markazi yaratildi." },
                    { title: "Xavfsizlik qoidalariga mos AI kuzatuv tizimi joriy etildi." }
                  ]
                },
                // Chemicals
              
                // Technology
                title_9: "Texnologiya",
                intro_9: {
                  main_text_9: "Texnologiya sanoati uchun xavfsiz va tezkor logistika",
                  text_1: "MMSH Logistics qimmatbaho texnologik mahsulotlar, jumladan, elektronika, yarimo‘tkazgichlar va ma’lumot markazlari serverlari uchun moslashtirilgan transport yechimlarini taqdim etadi. Biz texnologiya sanoati faqat tez yetkazib berishni emas, balki nozik komponentlarni himoya qilish uchun yuqori darajada xavfsiz va iqlim nazoratiga ega transport tizimlarini talab qilishini tushunamiz. Bizning logistika tarmog‘imiz xavfsiz muomala, real vaqt rejimida monitoring va ishlab chiqarish hamda tarqatish uchun tezkor yetkazib berish tizimini ta’minlaydi. AI yordamida kuzatuv va multimodal transport yechimlarimiz tranzit vaqtlarini qisqartiradi va operatsion xarajatlarni kamaytiradi, bu esa biznesga ta’minot zanjirining samaradorligini optimallashtirish imkonini beradi."
                },
              
                projects_9: {
                  title: "Texnologik yuk tashish yechimlaridagi ilg‘or ishlanmalar",
                  items: [
                    { title: "Elektronika uchun xavfsiz omborlarning kengaytirilishi." },
                    { title: "Real vaqt rejimida yuk kuzatuvi uchun IoT sensorlari." },
                    { title: "Yarimo‘tkazgichlar ta’minoti uchun optimallashtirilgan logistika." },
                    { title: "Qimmatbaho yuklar uchun ilg‘or xavfsizlik tizimlari." }
                  ]
                },
              
                completed_projects_9: {
                  title: "TUGALLANGAN LOYIHALAR",
                  items: [
                    { title: "Global yarimo‘tkazgich logistika tarmog‘i tashkil etildi." },
                    { title: "Nozik texnologik jo‘natmalar uchun AI boshqaruv tizimi joriy etildi." }
                  ]
                },
                // Technology
              
                // Groceries
                title_10: "Oziq-ovqat mahsulotlari",
                intro_10: {
                  main_text_10: "Tez va yangi yetkazib berish uchun oziq-ovqat logistikalari",
                  text_1: "MMSH Logistics haroratni boshqarish va vaqtga bog‘liq oziq-ovqat tarqatish xizmatlarini taqdim etadi. Biz yangi sabzavot va mevalar, sut mahsulotlari, go‘sht, muzlatilgan mahsulotlar va quruq oziq-ovqat yetkazib berishda ixtisoslashganmiz, bu esa tez buziladigan mahsulotlarning sifatini saqlashga yordam beradi. Bizning ilg‘or sovuq zanjir logistika tizimlarimiz iqlim nazorati ostidagi saqlash, real vaqt rejimida harorat monitoringi va ekspress yetkazib berish tarmoqlarini o‘z ichiga oladi. Biz yirik supermarket tarmoqlari yoki kichik mahalliy bozorlar uchun yetkazib berish tizimini optimallashtiramiz, buzilishlarning oldini olamiz va logistika samaradorligini oshiramiz."
                },
              
                projects_10: {
                  title: "Oziq-ovqat logistikasidagi innovatsiyalar",
                  items: [
                    { title: "Sovutilgan transport parkini kengaytirish." },
                    { title: "AI yordamida ta’minot zanjirini optimallashtirish." },
                    { title: "Yaroqlilik muddatini uzaytirish uchun ilg‘or qadoqlash." },
                    { title: "Organik oziq-ovqat mahsulotlari uchun barqaror logistika." }
                  ]
                },
              
                completed_projects_10: {
                  title: "TUGALLANGAN LOYIHALAR",
                  items: [
                    { title: "Oziq-ovqat mahsulotlari uchun haroratni boshqarish tarmog‘i yaratildi." },
                    { title: "Yangi mahsulotlar uchun AI boshqaruv tizimi integratsiya qilindi." }
                  ]
                },
                // Groceries         
                    // Pharmaceuticals
                    title_11: "Farmatsevtika",
                    intro_11: {
                      main_text_11: "Haroratni nazorat qiluvchi va reglamentga mos farmatsevtika logistikalari",
                      text_1: "MMSH Logistics farmatsevtika yuk tashish xizmatlarida ixtisoslashgan bo‘lib, haroratga sezgir dori vositalari, vaksinalar va tibbiy mahsulotlarning xavfsiz va samarali yetkazib berilishini ta’minlaydi. Biz real vaqt rejimida harorat monitoringi bilan ilg‘or sovuq zanjir logistikalaridan foydalanamiz va WHO hamda GDP reglamentlariga mos kelamiz. Bizning jamoamiz farmatsevtika mahsulotlarini eng yuqori ehtiyotkorlik bilan boshqarish bo‘yicha tayyorlangan bo‘lib, shifoxonalar, dorixonalar va tibbiy distribyutorlar uchun xavfsiz transport yechimlarini ta’minlaydi. Harorat nazorat qilinadigan saqlashdan tortib, tezkor so‘nggi mil yetkazib berishgacha, biz muhim sog‘liqni saqlash mahsulotlarining optimal sharoitlarda tashilishini kafolatlaymiz."
                    },
                  
                    projects_11: {
                      title: "Farmatsevtika yuk tashish yechimlaridagi ilg‘or ishlanmalar",
                      items: [
                        { title: "Haroratni nazorat qiluvchi omborlar kengaytirilishi." },
                        { title: "Tibbiy mahsulotlarni xavfsiz kuzatish uchun blokcheyn texnologiyasi." },
                        { title: "Vaksina tashish uchun AI yordamida boshqariladigan logistika." },
                        { title: "Shoshilinch tibbiy yuklarni tezkor yetkazib berish logistikasi." }
                      ]
                    },
                  
                    completed_projects_11: {
                      title: "TUGALLANGAN LOYIHALAR",
                      items: [
                        { title: "Vaksinalarni qit’alar bo‘ylab xavfsiz tarqatish." },
                        { title: "Farmatsevtika logistikasi uchun AI boshqaruv tizimiga asoslangan xavf menejmenti." }
                      ]
                    },
                    // Pharmaceuticals
                  
                    // Fashion
                    title_12: "Moda",
                    intro_12: {
                      main_text_12: "Moda sanoati uchun tezkor va moslashuvchan logistika",
                      text_1: "MMSH Logistics moda sanoati uchun maxsus yuk tashish yechimlarini taqdim etib, matolar, kiyim-kechak va aksessuarlarning o‘z vaqtida va samarali yetkazilishini ta’minlaydi. Biz ushbu sohaning tez o‘zgaruvchan talablariga moslashish uchun yuqori tezlik va aniqlik talab qilinishini tushunamiz. Bizning tarmog‘imiz moda brendlariga mahsulotlarini global bozorga o‘z vaqtida etkazish uchun ekspress havo yuk tashish, maxsus avtomobil transporti va samarali ombor xizmatlarini taqdim etadi. Aqlli inventarizatsiya boshqaruvi va AI yordamida talab prognozlash orqali, biz bizneslarga ta’minot zanjirlarini optimallashtirish, ortiqcha inventarizatsiyani kamaytirish va ekologik toza transport imkoniyatlari bilan barqarorlikni oshirishga yordam beramiz."
                    },
                  
                    projects_12: {
                      title: "Moda logistikasi bo‘yicha ilg‘or ishlanmalar",
                      items: [
                        { title: "Global moda tarqatish yo‘nalishlarini kengaytirish." },
                        { title: "Kiyim-kechak jo‘natmalari uchun real vaqt rejimida kuzatuv." },
                        { title: "Tez moda uchun optimallashtirilgan ta’minot zanjirlari." },
                        { title: "Barqaror brendlar uchun ekologik toza logistika." }
                      ]
                    },
                  
                    completed_projects_12: {
                      title: "TUGALLANGAN LOYIHALAR",
                      items: [
                        { title: "Mavsumiy moda mahsulotlari uchun ekspress logistika." },
                        { title: "Kiyim-kechak brendlari uchun AI yordamida talab prognozi." }
                      ]
                    },
                    // Fashion
                  
                    // Agricultural
                    title_13: "Qishloq xo‘jaligi",
                    intro_13: {
                      main_text_13: "Qishloq xo‘jaligi uchun ishonchli va barqaror logistika",
                      text_1: "MMSH Logistics qishloq xo‘jaligi mahsulotlarini, jumladan, don, yangi sabzavot va mevalar, o‘g‘itlar va chorva ozuqasini tashish bo‘yicha ixtisoslashgan. Bizning keng logistika tarmog‘imiz oziq-ovqat ishlab chiqaruvchilar, ulgurji sotuvchilar va eksportchilarga samarali fermerdan bozorgacha yetkazib berish tizimini taqdim etadi. Haroratni nazorat qiluvchi transport, maxsus ommaviy yuk tashuvchilar va o‘z vaqtida taqsimot yordamida, biz mahsulotlarning buzilishlarini kamaytirish va tranzit vaqtlarini qisqartirishga yordam beramiz."
                    },
                  
                    projects_13: {
                      title: "Qishloq xo‘jaligi logistikasi bo‘yicha ilg‘or ishlanmalar",
                      items: [
                        { title: "Tez buziladigan ekinlar uchun sovuq zanjir transportining kengayishi." },
                        { title: "Fermerlar kooperativlari uchun AI yordamida inventarizatsiya prognozlash." },
                        { title: "Don eksporti uchun optimallashtirilgan multimodal transport." },
                        { title: "Organik mahsulotlar uchun ekologik toza qadoqlash yechimlari." }
                      ]
                    },
                  
                    completed_projects_13: {
                      title: "TUGALLANGAN LOYIHALAR",
                      items: [
                        { title: "Fermerdan bozorgacha tezkor taqsimot tarmoqlari yaratildi." },
                        { title: "Ta’minot zanjirining kuzatilishini ta’minlash uchun blokcheyn texnologiyasi joriy etildi." }
                      ]
                    },
                    // Agricultural
                  
                    // Construction
                    title_14: "Qurilish",
                    intro_14: {
                      main_text_14: "Qurilish sanoati uchun og‘ir yuk tashish va samarali logistika",
                      text_1: "MMSH Logistics qurilish materiallari, jumladan, sement, po‘lat, yog‘och, og‘ir texnika va prefabrik strukturalarni tashish bo‘yicha xizmatlarni taqdim etadi. Bizning logistik yechimlarimiz yirik infratuzilma loyihalari, turar-joy qurilishi va tijorat qurilishlarini qo‘llab-quvvatlab, muhim materiallarning o‘z vaqtida va tejamkor yetkazilishini ta’minlaydi."
                    },
                  
                    projects_14: {
                      title: "Qurilish logistikasi bo‘yicha ilg‘or ishlanmalar",
                      items: [
                        { title: "Maxsus og‘ir yuk tashish transport vositalarining kengaytirilishi." },
                        { title: "Qurilish maydonlarida yetkazib berishni AI bilan boshqarish." },
                        { title: "Prefabrik binolar uchun optimallashtirilgan multimodal transport." },
                        { title: "Qurilish materiallari uchun barqaror ta’minot zanjiri yechimlari." }
                      ]
                    },
                  
                    completed_projects_14: {
                      title: "TUGALLANGAN LOYIHALAR",
                      items: [
                        { title: "Yirik infratuzilma loyihalari uchun o‘z vaqtida logistika yaratildi." },
                        { title: "Ommaviy materiallar yuk tashish uchun raqamli kuzatuv tizimi integratsiya qilindi." }
                      ]
                    },
                    // Construction
                        // Bulk
                        title_15: "Ommaviy yuklar",
                        intro_15: {
                          main_text_15: "Ommaviy yuklar uchun ishonchli va tejamkor logistika",
                          text_1: "MMSH Logistics xomashyo, foydali qazilmalar, qishloq xo‘jaligi mahsulotlari va sanoat tovarlarini tashish bo‘yicha ixtisoslashgan. Bizning quruq ommaviy, suyuq va bo‘lakli yuk tashish bo‘yicha tajribamiz global savdo yo‘nalishlarida samarali yuk harakatini ta’minlaydi. Maxsus kemalar, ommaviy yuk tashuvchilar va temir yo‘l yuk tashish tarmoqlaridan foydalanib, biz tranzit vaqtlari va xarajat samaradorligini optimallashtiramiz. Maxsus port inshootlari, avtomatlashtirilgan yuk tashish tizimlari va real vaqt rejimida kuzatuv bilan biz yuqori hajmli yuk tashish talab qiladigan sanoatlar uchun uzluksiz logistika yechimlarini taqdim etamiz."
                        },
                      
                        projects_15: {
                          title: "Ommaviy yuk tashish logistikasi bo‘yicha ilg‘or ishlanmalar",
                          items: [
                            { title: "Global savdo uchun ommaviy yuk tashuvchi flotini kengaytirish." },
                            { title: "AI yordamida yuklash va tushirish operatsiyalarini optimallashtirish." },
                            { title: "Portlarda avtomatlashtirilgan ommaviy yuk tashish tizimlarini joriy etish." },
                            { title: "Ommaviy materiallarni tashish uchun ekologik toza logistika yechimlari." }
                          ]
                        },
                      
                        completed_projects_15: {
                          title: "TUGALLANGAN LOYIHALAR",
                          items: [
                            { title: "Ommaviy yuk tashish uchun multimodal yechimlar ishlab chiqildi." },
                            { title: "Ommaviy yuk jo‘natmalarini real vaqt rejimida kuzatish uchun raqamli monitoring integratsiya qilindi." }
                          ]
                        },
                        // Bulk
                      
                        // Expensive Cargo
                        title_16: "Qimmatbaho yuklar",
                        intro_16: {
                          main_text_16: "Qimmatbaho tovarlar uchun xavfsiz va maxsus logistika",
                          text_1: "MMSH Logistics qimmatbaho va nozik yuklar, jumladan, hashamatli mahsulotlar, zargarlik buyumlari, elektronika, san’at asarlari va moliyaviy aktivlar uchun premium transport xizmatlarini taqdim etadi. Biz qimmatbaho jo‘natmalarni yetkazishda xavfsizlik, maxfiylik va samaradorlik muhim ekanligini tushunamiz. Bizning logistika xizmatlarimiz maxsus zirhli transport, haroratni nazorat qiluvchi saqlash va maxsus xavfsizlik qo‘riqchilari orqali yuklaringizni to‘liq himoya qilishni ta’minlaydi."
                        },
                      
                        projects_16: {
                          title: "Qimmatbaho yuk tashish bo‘yicha ilg‘or ishlanmalar",
                          items: [
                            { title: "Hashamatli mahsulotlar uchun xavfsiz logistika tarmoqlarining kengaytirilishi." },
                            { title: "Qimmatbaho jo‘natmalar uchun AI asosida xavf tahlili." },
                            { title: "Ombor kirishiga biometrik xavfsizlik tizimlarini integratsiya qilish." },
                            { title: "Qimmatbaho yuklarni multimodal transport orqali optimallashtirish." }
                          ]
                        },
                      
                        completed_projects_16: {
                          title: "TUGALLANGAN LOYIHALAR",
                          items: [
                            { title: "Zargarlik buyumlarini tashish uchun global xavfsiz yo‘nalishlar yaratildi." },
                            { title: "Elektronika uchun zirhli transport yechimlari ishlab chiqildi." }
                          ]
                        },
                        // Expensive Cargo
                      
                        // Heavy Cargo
                        title_17: "Og‘ir yuklar",
                        intro_17: {
                          main_text_17: "Og‘ir yuklar uchun ishonchli va maxsus logistika",
                          text_1: "MMSH Logistics yirik sanoat uskunalari, qurilish texnikasi, shamol turbinalari va infratuzilma komponentlarini tashish uchun maxsus transport xizmatlarini taqdim etadi. Biz ekstremal og‘irlik va o‘lcham talablariga mos keladigan transport tizimlarini taklif etamiz. Bizning xizmatlarimiz maxsus platformali tirkamalar, past yuk tashuvchilar, modulli transport tizimlari va og‘ir yuk tashish kemalaridan foydalanishni o‘z ichiga oladi."
                        },
                      
                        projects_17: {
                          title: "Og‘ir yuk tashish bo‘yicha ilg‘or ishlanmalar",
                          items: [
                            { title: "Maxsus og‘ir yuk tashish flotining kengaytirilishi." },
                            { title: "Yirik yuklarni tashish uchun AI asosida yo‘nalish optimallashtirish." },
                            { title: "Sanoat texnikasi uchun real vaqt rejimida kuzatuv integratsiyasi." },
                            { title: "Yirik yuklarni tashish logistikasini optimallashtirish." }
                          ]
                        },
                      
                        completed_projects_17: {
                          title: "TUGALLANGAN LOYIHALAR",
                          items: [
                            { title: "Yirik yuk tashish uchun multimodal yechimlar ishlab chiqildi." },
                            { title: "Xalqaro og‘ir texnika yuk tashish muvaffaqiyatli amalga oshirildi." }
                          ]
                        },
                        // Heavy Cargo
                      
                        // Liquid Cargo
                        title_18: "Suyuq yuklar",
                        intro_18: {
                          main_text_18: "Suyuq yuklar uchun maxsus va xavfsiz logistika",
                          text_1: "MMSH Logistics neft mahsulotlari, kimyoviy moddalar, oziq-ovqat suyuqliklari va sanoat suyuqliklarini xavfsiz va samarali tashish uchun transport yechimlarini taqdim etadi. Suyuq yuk tashish maxsus tanklar, haroratni nazorat qiluvchi saqlash va qat’iy me’yoriy talablarga rioya qilishni talab qiladi. Bizning transport parkimiz maxsus ISO tank konteynerlari, fleksitanklar va ommaviy suyuq yuk tashuvchilardan iborat bo‘lib, eng yuqori xavfsizlik va samaradorlikni ta’minlaydi."
                        },
                      
                        projects_18: {
                          title: "Suyuq yuk tashish bo‘yicha ilg‘or ishlanmalar",
                          items: [
                            { title: "Oziq-ovqat suyuqliklari uchun transport flotining kengaytirilishi." },
                            { title: "IoT asosida ishlaydigan to‘kilish oldini olish tizimlarini joriy etish." },
                            { title: "Kimyoviy suyuqliklar uchun optimallashtirilgan multimodal transport." },
                            { title: "Ekologik toza suyuq yuk saqlash yechimlarini ishlab chiqish." }
                          ]
                        },
                      
                        completed_projects_18: {
                          title: "TUGALLANGAN LOYIHALAR",
                          items: [
                            { title: "Neft mahsulotlarini tashish uchun xavfsiz va tezkor yo‘nalishlar yaratildi." },
                            { title: "Suyuq yuk jo‘natmalarini real vaqt rejimida kuzatish tizimi muvaffaqiyatli joriy etildi." }
                          ]
                        },
                        // Liquid Cargo
                            // Passenger Cars
                            title_19: "Yo‘lovchi avtomobillari",
                            intro_19: {
                              main_text_19: "Yo‘lovchi avtomobillarini samarali va xavfsiz tashish logistikalari",
                              text_1: "MMSH Logistics yo‘lovchi avtomobillarini, jumladan, hashamatli mashinalar, elektr avtomobillar (EV) va tijorat flotlarini xavfsiz va samarali yetkazib berish bo‘yicha ixtisoslashgan. Bizning keng qamrovli logistika tarmog‘imiz avtomobillarni yo‘l, temir yo‘l, dengiz va havo transporti orqali uzluksiz tashish imkonini beradi. Ishlab chiqaruvchilar, dilerlar va xususiy mijozlar uchun xizmat ko‘rsatamiz. Biz qimmatbaho va klassik avtomobillarni ekologik zararlaridan himoya qilish uchun maxsus yopiq transport vositalaridan foydalanamiz. Multimodal yechimlarimiz xarajatlarni optimallashtiradi va eng yuqori xavfsizlik standartlarini ta’minlaydi. Real vaqt rejimida GPS kuzatuv, maxsus sug‘urta variantlari va avtomobillarni maxsus tashish yechimlari sizga xavfsiz va muammosiz tashish tajribasini taqdim etadi."
                            },
                          
                            projects_19: {
                              title: "Yo‘lovchi avtomobillarini tashish bo‘yicha ilg‘or ishlanmalar",
                              items: [
                                { title: "Hashamatli avtomobillar uchun yopiq transport flotini kengaytirish." },
                                { title: "AI asosida avtomobillar uchun yo‘nalishlarni optimallashtirish." },
                                { title: "Elektr avtomobillarni multimodal tashish tizimining takomillashtirilishi." },
                                { title: "Barqaror avtomobil tashish yechimlarini ishlab chiqish." }
                              ]
                            },
                          
                            completed_projects_19: {
                              title: "TUGALLANGAN LOYIHALAR",
                              items: [
                                { title: "Logistika uchun global avtomobil tashish yo‘nalishlari muvaffaqiyatli tashkil etildi." },
                                { title: "Real vaqt rejimida avtomobil jo‘natmalarini kuzatish uchun GPS integratsiya qilindi." }
                              ]
                            },
                            // Passenger Cars
                          
                            // Reefer Cargo
                            title_20: "Muzlatilgan yuklar",
                            intro_20: {
                              main_text_20: "Muzlatilgan yuklar uchun ishonchli va haroratni nazorat qiluvchi logistika",
                              text_1: "MMSH Logistics haroratga sezgir mahsulotlar, jumladan, yangi sabzavot va mevalar, sut mahsulotlari, farmatsevtika mahsulotlari, dengiz mahsulotlari va muzlatilgan oziq-ovqatlarni tashish bo‘yicha xizmatlar taqdim etadi. Bizning muzlatilgan yuk tashish logistika yechimlarimiz butun ta’minot zanjiri davomida aniq harorat nazoratini ta’minlaydi. Zamonaviy sovutilgan konteynerlar, sovuq omborxona xizmatlari va iqlim nazorat qilinadigan transport vositalari buzilishlarning oldini olish va oziq-ovqat xavfsizligi hamda farmatsevtika reglamentlariga mos kelishiga yordam beradi."
                            },
                          
                            projects_20: {
                              title: "Muzlatilgan yuk tashish bo‘yicha ilg‘or ishlanmalar",
                              items: [
                                { title: "Yangi mahsulotlar uchun sovutilgan transport flotining kengaytirilishi." },
                                { title: "Farmatsevtika logistikasi uchun AI asosida harorat monitoringi." },
                                { title: "Muzlatilgan va yangi oziq-ovqat mahsulotlari uchun optimallashtirilgan multimodal yechimlar." },
                                { title: "Energiya tejovchi sovutilgan saqlash omborlarini ishlab chiqish." }
                              ]
                            },
                          
                            completed_projects_20: {
                              title: "TUGALLANGAN LOYIHALAR",
                              items: [
                                { title: "Oziq-ovqat va tibbiy yuklar uchun global sovuq zanjir logistikasi yaratildi." },
                                { title: "Real vaqt rejimida harorat monitoringi uchun aqlli muzlatilgan yuk kuzatuvi integratsiya qilindi." }
                              ]
                            },
                            // Reefer Cargo
                          
                            // Drivers' Office
                            title_21: "Haydovchilar ofisi",
                            intro_21: {
                              main_text_21: "Professional haydovchilar uchun qulay va mukofotlovchi ish muhiti",
                              text_1: "MMSH Logistics kompaniyasida biz haydovchilarimizni operatsiyalarimizning asosi deb bilamiz. Biz ularga professional, qulay va mukofotlovchi ish muhitini ta’minlashga sodiqmiz. Zamonaviy transport vositalarimiz, yaxshi rejalashtirilgan yo‘nalishlarimiz va ilg‘or logistika texnologiyalarimiz har bir safarni samarali va qulay qilishga yordam beradi. Raqobatbardosh ish haqi, martaba o‘sishi imkoniyatlari va mustahkam qo‘llab-quvvatlash tizimi bilan biz haydovchilarimizni har tomonlama qo‘llab-quvvatlaymiz."
                            },
                          
                            texts_21: {
                              main: "MMSH Logistics ning asosiy afzalliklari",
                              mini_1: "Xizmatlarimizdan qulay foydalanish",
                              mini_2: "Dispetcherlar bilan tezkor aloqa",
                              mini_3: "Kuniga 200+ yangi yuk buyurtmalariga kirish",
                              mini_4: "Vaqtni tejovchi avtomatlashtirilgan dispetcher tizimi",
                              mini_5: "Real vaqt rejimida bildirishnomalar bilan yuklash/tushirish kechikishlarini kamaytirish",
                              mini_6: "Nizolarni oldini olish uchun aniq kuzatuv tizimi",
                              mini_7: "Shaxsiy to‘lov rejalari bilan aqlli moliyaviy rejalashtirish",
                              mini_8: "AI yordamida yo‘nalish optimallashtirish orqali xarajatlarni kamaytirish"
                            },
                            // Drivers' Office
                          
                            // Payments
                            title_22: "To‘lovlar",
                            intro_22: {
                              main_text_22: "Haydovchilarimiz uchun oson va shaffof to‘lov tizimi",
                              text_1: "MMSH Logistics kompaniyasida biz haydovchilarimizning moliyaviy barqarorligi va qulayligi ustuvor ekanligini ta’minlaymiz. Bizning ilg‘or hisob-kitob va to‘lov tizimlarimiz to‘lovlarni o‘z vaqtida, aniq va shaffof ravishda amalga oshirishni kafolatlaydi, bu esa moliyaviy noaniqlik stressini yo‘q qiladi. Avtomatlashtirilgan ish haqi hisoblash, aniq hujjatlashtirish va maxsus qo‘llab-quvvatlash jamoalari orqali haydovchilarimiz safarlariga e’tibor qaratishlari mumkin. Bizning optimallashtirilgan jarayonlarimiz o‘z vaqtida to‘lovlar, moliyaviy hisobotlarga oson kirish va muammosiz tranzaksiyalarni kafolatlaydi. MMSH Logistics kompaniyasida biz haydovchilarimizni faqat xodim emas, balki muvaffaqiyatimizning muhim hamkori deb hisoblaymiz. Samaradorlik, adolat va moliyaviy xavfsizlikka bo‘lgan sadoqatimiz bizni logistika sanoatida eng yaxshi tanlovga aylantiradi. Agar sizda savol(lar) bo‘lsa, quyidagi telefon raqamlariga qo‘ng‘iroq qiling."
                            },
                            // Payments        
                                // Movement Restriction
                                title_23: "Harakatlanish cheklovlari",
                                intro_23: {
                                  main_text_23: "Evrozonada haydovchilar uchun harakat cheklovlarini tushunish",
                                  text_1: "Evrozonada Yevroittifoqga a’zo bo‘lmagan davlat fuqarosi sifatida haydash va ishlash qattiq harakat cheklovlari va huquqiy talablar bilan bog‘liq. Qonuniy ishlash uchun haydovchilar viza qoidalariga, yo‘l transporti qonunlariga va chegaralar nazoratiga rioya qilishlari kerak. Yevropa vizasi (Shengen ish vizasi) Yevropa mamlakatlarida ishlashni istagan Yevroittifoqga a’zo bo‘lmagan fuqarolar uchun majburiy hisoblanadi. Ba’zi holatlarda milliy siyosatga qarab qo‘shimcha ish ruxsatnomalari talab qilinishi mumkin. Bundan tashqari, ekologik reglamentlar, to‘lov tizimlari va Yevroittifoq tomonidan joriy etilgan haydash soatlari cheklovlari chegaralararo harakatga ta’sir qilishi mumkin. MMSH Logistics kompaniyasida biz haydovchilarimizni viza arizalari, ish ruxsatnomalari va transport qonunlariga rioya qilish bo‘yicha yo‘riqnomalar bilan qo‘llab-quvvatlaymiz, bu esa ularning ishlash jarayonini osonlashtirish va jarimalardan qochishga yordam beradi. Harakat cheklovlari va ish ruxsatnomalari bo‘yicha savollaringiz bo‘lsa, iltimos, quyidagi telefon raqamlariga murojaat qiling."
                                },
                                // Movement Restriction
                              
                                // Fuel Cards
                                title_24: "Yoqilg‘i kartalari",
                                intro_24: {
                                  main_text_24: "MMSH Logistics haydovchilari uchun yoqilg‘i kartalari siyosati",
                                  text_1: "MMSH Logistics kompaniyasida biz uzoq masofali safarlar davomida kutilmagan vaziyatlar yuzaga kelishi mumkinligini tushunamiz. Haydovchilarga o‘z yoqilg‘i xarajatlarini mustaqil boshqarishni tavsiya qilsak ham, yoqilg‘i kartalari faqat favqulodda holatlarda taqdim etiladi. Bunday holatlarga haydovchi kutilmagan sharoitlar tufayli vaqtincha yoqilg‘i xarajatlarini qoplash imkoniga ega bo‘lmaganda yo‘qotishlar kiradi. Yoqilg‘i kartalari faqat oxirgi chora sifatida beriladi va oldindan tasdiqlash talab etiladi. Bizning asosiy maqsadimiz haydovchilarimizni muhim paytlarda qo‘llab-quvvatlash, shu bilan birga moliyaviy barqarorlikni saqlashdir. Agar yoqilg‘i xarajatlari bo‘yicha yordamga muhtoj bo‘lsangiz, tegishli bo‘limga murojaat qiling."
                                },
                                // Fuel Cards
                              
                                // Business Ethics
                                title_25: "MMSHning biznes etikasi",
                                intro_25: {
                                  main_text_25: "Etik va mas’uliyatli logistika yo‘nalishimiz",
                                  text_1: "MMSH Logistics kompaniyasida halollik, mas’uliyat va hurmat bizning biznes etikamizning asosini tashkil etadi. Biz har bir tranzaksiya va hamkorlikda shaffoflikni ta’minlashga ustuvor ahamiyat beramiz. Barqarorlikka bo‘lgan intilishimiz ekologik toza amaliyotlar va samarali logistika yechimlarini joriy etishga undaydi, bu esa atrof-muhitga ta’sirni kamaytirishga yordam beradi. Mijozlarimiz va xodimlarimizning ishonchini qadrlab, o‘zaro hurmat, xilma-xillik va inklyuzivlik asosida ish muhiti yaratamiz. Eng yuqori etik standartlarga amal qilish orqali, MMSH Logistics kompaniyasi ishonchli hamkor, innovatsiyalar yetakchisi va uzoq muddatli muvaffaqiyatga sodiq korxona sifatida o‘z mavqeini mustahkamlaydi."
                                },
                                // Business Ethics
                              
                                // Career
                                title_26: "MMSHda karyera",
                                intro_26: {
                                  main_text_26: "MMSH Logistics da muvaffaqiyatli karyera yaratish",
                                  text_1: "MMSH Logistics kompaniyasida biz karyera rivoji o‘sish, innovatsiyalar va qo‘llab-quvvatlovchi muhitga asoslangan deb hisoblaymiz. Biz xodimlarimizga o‘z mahoratlarini rivojlantirish, kasbiy o‘sish va logistika sanoatida muhim ta’sir ko‘rsatish imkoniyatlarini yaratishga sodiqmiz. Jamoaviy ish, ijodkorlik va uzluksiz o‘rganishni qadrlaydigan ish muhiti orqali biz har bir xodimning o‘z salohiyatini to‘liq ro‘yobga chiqarishiga yordam beramiz.",
                                  join_our_team: "Bizning jamoamizga qo‘shiling",
                                  view_vacancies: "Bo‘sh ish o‘rinlarini ko‘rish",
                                  apply_for_internship: "Amaliyotga ariza topshirish"
                                },
                                // Career
                              
                                // Vacancies
                                title_27: "MMSHdagi ish imkoniyatlari",
                                intro_27: {
                                  main_text_27: "MMSH Logistics kompaniyasidagi bo‘sh ish o‘rinlarini o‘rganing",
                                  text_1: "MMSH Logistics kompaniyasida biz kasbiy o‘sish, innovatsiyalar va qo‘llab-quvvatlovchi muhitni istagan mutaxassislar uchun dinamik martaba imkoniyatlarini taqdim etamiz. Xodimlarimizning ko‘nikmalarini rivojlantirish, kasbiy jihatdan rivojlanish va logistika sanoatida muhim ta’sir ko‘rsatishlariga yordam berishga sodiqmiz. Bizning ish muhiti jamoaviylik, ijodkorlik va uzluksiz o‘rganishni rag‘batlantiradi.",
                                  vacancies: "Bo‘sh ish o‘rinlarini ko‘rish"
                                },
                                // Vacancies
                              
                                // Internship
                                title_28: "MMSHda amaliyot",
                                intro_28: {
                                  main_text_28: "MMSH Logistics kompaniyasidagi amaliyot imkoniyatlarini o‘rganing",
                                  text_1: "MMSH Logistics kompaniyasida biz kasbiy o‘sish, innovatsiyalar va qo‘llab-quvvatlovchi muhitni istagan mutaxassislar uchun dinamik martaba imkoniyatlarini taqdim etamiz. Biz xodimlarimizning ko‘nikmalarini rivojlantirish, kasbiy jihatdan rivojlanish va logistika sanoatida muhim ta’sir ko‘rsatishlariga yordam berishga sodiqmiz."
                                },
                                internship_benefits: {
                                  main_title: "Nega MMSH Logistics da amaliyot o‘tash kerak?",
                                  description: "MMSH Logistics kompaniyasidagi amaliyot faqat o‘quv jarayoni emas — bu xalqaro logistika olamida martabangizni boshlash uchun imkoniyatdir.",
                                  benefits: {
                                    experience: {
                                      title: "Amaliy tajriba",
                                      description: "Logistika jarayonlari, ta’minot zanjiri boshqaruvi, bojxona rasmiylashtiruvi va xalqaro savdo qoidalari bo‘yicha to‘g‘ridan-to‘g‘ri tajriba oling."
                                    },
                                    mentorship: {
                                      title: "Soha mutaxassislaridan mentorlik",
                                      description: "Sizga zaruriy texnik va biznes ko‘nikmalarni rivojlantirishga yordam beradigan tajribali mutaxassislar bilan ishlang."
                                    },
                                    career_growth: {
                                      title: "Martaba rivoji imkoniyatlari",
                                      description: "Ko‘plab amaliyotchilarimiz doimiy lavozimlarga o‘tishadi, bu esa uzoq muddatli logistika martabasiga yo‘l ochadi."
                                    }
                                  },
                                  conclusion: "MMSH Logistics kompaniyasida amaliyot o‘rganish imkoniyati emas, balki logistika sohasidagi kelajak martabangiz uchun poydevor qo‘yish imkoniyatidir!"
                                },
                                // Internship
                // Locations
                locations: {
                    city: "Shahar",
                    phone_number: "Telefon raqami",
                    data: [
                    { country: "cn", city: "Alashankou, Xitoy", phone: "+86 901 123 45 67" },
                    { country: "us", city: "Ohio, AQSh", phone: "+1 614 555 78 90" },
                    { country: "de", city: "Frankfurt, Germaniya", phone: "+49 69 123 45 67" },
                    { country: "uz", city: "Andijon, O‘zbekiston", phone: "+998 74 456 78 90" },
                    { country: "tr", city: "Istanbul, Turkiya", phone: "+90 212 987 65 43" }
                    ],
                    data2: [
                    { country: "jp", city: "Kyoto, Yaponiya", phone: "+81 75 234 56 78" },
                    { country: "it", city: "Milan, Italiya", phone: "+39 02 123 45 67" },
                    { country: "it", city: "Rim, Italiya", phone: "+39 06 789 01 23" },
                    { country: "ru", city: "Moskva, Rossiya", phone: "+33 1 234 56 78" }, 
                    { country: "cn", city: "ShengZhen, Xitoy", phone: "+86 901 234 56 78" }
                    ]
                },
                // Locations

                // Consulting
                consulting_title: "Konsalting",
                consulting_heading: "Ishonchli logistika hamkori",
                consulting_description: "Bugungi tezkor dunyoda bizneslar raqobatda oldinda bo‘lish uchun ishonchli, samarali va innovatsion logistika yechimlariga muhtoj. MMSH Logistics kompaniyasida biz har bir jo‘natma shunchaki yuk emasligini tushunamiz—bu sizning biznes obro‘yingiz, mijoz ishonchi va o‘sish imkoniyatlaridir. Shuning uchun biz biznesingizni chegaralar bo‘ylab muammosiz kengaytirishga yordam beradigan, texnologiyaga asoslangan, samarali va tejamkor logistika xizmatlarini taqdim etamiz.",
                contact_email: "info@mmshlogistics.com",
                contact_phone: "+998 90 123 45 67",
                // Consulting

                // Customs Services
                customs_services_title: "Bojxona xizmatlari",
                customs_services_heading: "Samarali va ishonchli bojxona yechimlari",
                customs_services_description: "MMSH Logistics kompaniyasida biz xalqaro savdoda bojxona qoidalariga rioya qilish eng muhim jihatlardan biri ekanligini tushunamiz. Bizning bojxona xizmatlarimiz yuklarning chegaralar bo‘ylab muammosiz va samarali o‘tishini ta’minlaydi. Import yoki eksport bo‘lishidan qat’i nazar, MMSH Logistics kompaniyasi bojxona hujjatlarini tayyorlash, tariflarni belgilash, boj to‘lovlarini optimallashtirish va reglamentlarga moslik bo‘yicha moslashtirilgan yechimlarni taklif etadi.",
                // Customs Services

                // Project Logistics
                project_logistics_title: "Loyiha logistikalari",
                project_logistics_heading: "Kompleks loyiha logistikasi yechimlari",
                project_logistics_description: "MMSH Logistics kompaniyasi yirik sanoat va infratuzilma loyihalari uchun maxsus logistika yechimlarini taqdim etishga ixtisoslashgan. Bizning loyiha logistikasi bo‘yicha tajribamiz ortiqcha yuklar, og‘ir va vaqtga bog‘liq jo‘natmalarni xalqaro chegaralar orqali muammosiz tashishni ta’minlaydi.",
                // Project Logistics

                // Warehouse Services
                warehouse_services_title: "Ombor xizmatlari",
                warehouse_services_heading: "Xavfsiz va samarali ombor yechimlari",
                warehouse_services_description: "MMSH Logistics kompaniyasida biz ta’minot zanjiringizni soddalashtirish uchun yuqori darajadagi ombor xizmatlarini taklif qilamiz. Zamonaviy saqlash inshootlarimiz xavfsiz, harorat nazorat qilinadigan va yuqori samarali ombor echimlarini taqdim etadi.",
                // Warehouse Services

                // Insurance
                insurance_services_title: "Yuk sug‘urta xizmatlari",
                insurance_services_heading: "Maksimal xavfsizlik uchun keng qamrovli yuk sug‘urtasi",
                insurance_services_description: "MMSH Logistics mijozlariga ishonchli yuk sug‘urtasi echimlarini taklif etadi. Bizning 'Barcha Xavflar' sug‘urtasi eng qulay va xavfsiz qamrovni ta’minlaydi va yuk tashish vaqtida to‘liq himoyani kafolatlaydi.",
                insurance_services_providers: "MMSH Logistics etakchi sug‘urta agentligi 'Inson' bilan hamkorlik qiladi va €1,500,000 gacha bo‘lgan yuk sug‘urtasini ta’minlaydi.",
                insurance_services_benefits_heading: "MMSH Logistics da yuk sug‘urtasining asosiy afzalliklari",
                insurance_services_coverage_heading: "Sug‘urta qamrovi variantlari",
                insurance_services_options_heading: "Mavjud sug‘urta variantlari",
                insurance_services_damage_handling_heading: "Yuk shikastlanishini boshqarish",
                // Insurance

                // Vehicle Types
                vehicle_types: {
                    title: "TRANSPORT TURLARI",
                    description: "Dengiz transporti uchun MMSH Logistics quyidagi maxsus moslashtirilgan konteyner turlaridan foydalanadi:",
                    items: [
                    "Turli o‘lchamdagi ISO konteynerlari",
                    "Ortib boruvchi, ommaviy va bo‘lak yuklar uchun maxsus konteynerlar",
                    "Suyuq tovarlarni tashish uchun tank konteynerlar",
                    "Tez buziladigan mahsulotlar uchun sovutilgan konteynerlar",
                    "Avtomobillarni, kichik yuklarni va xavfli materiallarni tashish uchun mo‘ljallangan konteynerlar"
                    ]
                },

                // Capabilities
                capabilities: {
                    title: "BIZNING IMKONIYATLARIMIZ",
                    description: "MMSH Logistics temiryo‘l transporti bo‘yicha maxsus xizmatlar taqdim etib, xavfsiz va samarali yetkazib berishni ta’minlaydi.",
                    items: [
                    "Termos vagonlar, izotermalar va sovutilgan vagonlar orqali harorat nazorat qilinadigan transport.",
                    "Avtomobillar, texnika va uskunalarni tashish.",
                    "Tez buziladigan mahsulotlarni temiryo‘l orqali samarali yetkazish.",
                    "120 m3 dan ortiq hajmli yirik, engil yuklarni tashish.",
                    "Uzoq masofalarga tezkor poyezdlar orqali yuk yetkazish."
                    ],
                    final_note: "MMSH ishonchli, moslashuvchan va shaxsiylashtirilgan logistika echimlarini taqdim etishga sodiqdir."
                },
                // Regulations
                regulations: {
                    title: "QOIDALAR/HUJJATLAR",
                    description: "Dengiz yuk tashish ko‘plab milliy va xalqaro huquqiy qoidalarga bo‘ysunadi.",
                    list: [
                    { title: "Asosiy konvensiyalar", content: "O‘zbekistonda dengiz transporti Birlashgan Millatlar Tashkiloti konvensiyasiga rioya qiladi." },
                    { title: "Milliy qonunchilik", content: "Xalqaro kelishuvlarga qo‘shimcha ravishda, MMSH O‘zbekistonning milliy qonunlariga rioya qiladi." },
                    { title: "Maxsus nazorat", content: "MMSH Logistics dengiz transporti qoidalaridagi o‘zgarishlarni diqqat bilan kuzatib boradi." },
                    { title: "Hujjatlar", content: "Bizning jamoamiz barcha zarur yuk tashish hujjatlari bo‘yicha to‘liq yordam ko‘rsatadi." }
                    ],
                    conclusion: "Huquqiy moslik va operatsion mukammallikka e’tibor qaratgan holda, MMSH Logistics har bir jo‘natmaning xavfsiz bajarilishini ta’minlaydi."
                },
                // Regulations

                start: {
                    trucks: "Yuk mashinalari",
                    train: "Poyezdlar",
                    boats: "Kema transporti",
                    air: "Havo transporti",
                    multimodal: "Multimodal transport",
                    collective: "Jamoaviy yuk tashish"
                },

                big: {
                    trucks: "Bizning kompaniya eng zamonaviy transport vositalari bilan tezkor va ishonchli yetkazib berishni ta’minlaydi.",
                    train: "Biz yuklarni samarali yetkazish uchun temir yo‘l transportining kuchidan foydalanamiz.",
                    boats: "Biz dengiz transportining imkoniyatlaridan to‘liq foydalanamiz.",
                    air: "Biz yuklarni tez va samarali havo transporti orqali yetkazib beramiz.",
                    multimodal: "Biz uzluksiz multimodal transport xizmatlarini taqdim etamiz.",
                    collective: "Biz jamoaviy yuk tashish uchun qulay yechimlarni taklif qilamiz."
                },

                logo_text: "MMSH Logistics",
                about_mmsh: "MMSH Logistics korporativ mijozlar uchun mukammallik, ishonchlilik va samaradorlikni yetkazib berishga sodiqdir. Biz sifat kafolati bilan ta’minlangan xizmatlarni taklif etamiz va mijoz ehtiyojlariga mos moslashtirilgan, xavfsiz transport yechimlarini taqdim etamiz. Tajribali jamoamiz, ilg‘or texnologiyalarimiz va mijozlar qoniqishiga bo‘lgan sadoqatimiz bilan ta’minot zanjirining har bir bosqichini optimallashtiramiz, xarajatlarni kamaytiramiz va operatsion samaradorlikni oshiramiz. MMSH Logistics da sizning muvaffaqiyatingiz bizning ustuvorligimizdir.",

                career: "MMSHda martaba",
                work: "MMSH Logistics da cheksiz imkoniyatlar va innovatsiyalar dunyosiga qadam qo‘ying.",

                Responsible: "Mas’uliyatli",
                Supportive: "Qo‘llab-quvvatlovchi",
                Comfortable: "Qulay",

                responsible: "MMSH da biz uzluksiz logistika yechimlarini taqdim etish uchun to‘liq javobgarlikni o‘z zimmamizga olamiz. Bizning jamoamiz yuklarning o‘z vaqtida va xavfsiz yetkazilishini ta’minlaydi.",
                supportive: "Biz kuchli hamkorlik va doimiy qo‘llab-quvvatlashga ishonamiz. Xalqaro yuk tashishdan mahalliy transportgacha bo‘lgan barcha bosqichlarda mutaxassislarimiz mijozlarimizga yordam berishga tayyor.",
                comfortable: "Bizning qulay xizmatlarimiz va samarali operatsiyalarimiz logistika jarayonlarini stresssiz qiladi. Biz mijozlarimizga shaffof aloqa va muammosiz yuk jo‘natmalarini kafolatlaymiz.",

                SignUp: "Bugun ro‘yxatdan o‘ting",
                Learn_more: "Batafsil ma’lumot",
                Search_more: "Ko‘proq qidiring",
                Back_to_top: "Yuqoriga qaytish",
                View_details: "Tafsilotlarni ko‘rish",
                loading: "Yuklanmoqda...",

                regions: {
                    china_team_leader: "Xitoy jamoasi rahbari",
                    central_asia_russia_team_leader: "Markaziy Osiyo va Rossiya jamoasi rahbari",
                    europe_team_leader: "Yevropa jamoasi rahbari"
                },

                names: {
                    abdulloh: "Abdulloh",
                    nuriddin: "Nuriddin",
                    ulugbek: "Ulug‘bek"
                },

                texts: {
                    trustworthy_company: "Ko‘plab sertifikatlarga ega ishonchli kompaniya.",
                    shipping_with_trains: "Biz shuningdek poyezd orqali yuk tashish xizmatlarini ham taklif qilamiz.",
                    experienced_drivers: "Tajribali haydovchilar istalgan vaqtda sizga yordam berishga tayyor."
                },

                write: {
                    km: "92.41",
                    done: "12731",
                    routes: "975",
                    loaders: "3211",
                    drivers: "7445"
                },

                write_2: {
                    km_text: "Million kilometr",
                    done_text: "Bajarilgan buyurtmalar",
                    routes_text: "Maqsadli savdo yo‘nalishlari",
                    loaders_text: "Korporativ mijozlar",
                    drivers_text: "Ishonchli pudratchilar"
                },

                write_3: {
                    more: "Bu haqida ko‘proq",
                    see_statistics: "Statistikani ko‘rish",
                    learn_more: "Batafsil ma’lumot",
                    see: "Ko‘rish",
                    check: "Tekshirish"
                },

                Special: {
                    Industry_Solutions: "Sanoat yechimlari",
                    Special_Loads: "Maxsus yuklar",
                    Learn_more: "Batafsil ma’lumot"
                },

                Career: {
                    make_career: "MMSHda martaba",
                    text: "MMSH mutaxassislari marketing strategiyasi, savdo boshqaruvi, mijozlar bilan munosabatlar, tadbirlarni rejalashtirish va mehmonxona boshqaruvi sohalarida ishlashlari mumkin.",
                    learn_more: "Batafsil ma’lumot"
                },

                News: {
                    News_in_Company: "Kompaniyadagi yangiliklar",
                    Growth_in_MMSH: "MMSH da o‘sish",
                    MMSH_is: "MMSH ambitsiyali odamlar uchun ochiq",
                    News_of_MMSH: "MMSH yangiliklari",
                    learn_more: "Batafsil ma’lumot",
                    show_less: "Kamroq ko‘rsatish",
                    text_1: "MMSH kompaniyasi o‘z flotiga yangi zamonaviy yuk mashinalarini qo‘shganini mamnuniyat bilan e’lon qiladi.",
                    text_2: "MMSH o‘z xodimlarining fidoyiligi va malakasini yuqori baholaydi.",
                    full_text_1: "MMSH Logistics butun dunyo bo‘ylab o‘z faoliyatini kengaytirishda davom etmoqda.",
                    full_text_2: "MMSH o‘z xodimlariga kasbiy rivojlanish uchun keng imkoniyatlar taqdim etadi."
                },

                sections: {
                    mmsh: "MMSH",
                    transport: "Transport",
                    industry_solutions: "Sanoat yechimlari",
                    special_loads: "Maxsus yuklar",
                    for_drivers: "Haydovchilar",
                    contacts: "Aloqa",
                    career: "Martaba"
                },

                links: {
                    about_company: "Kompaniya haqida",
                    history_mission: "Tarix va Missiya",
                    certificates: "Sertifikatlar",
                    trucks: "Yuk mashinalari",
                    trains: "Poyezdlar",
                    ships: "Kemalar",
                    air: "Havo transporti",
                    multimodal: "Multimodal",
                    chemicals: "Kimyoviy mahsulotlar",
                    technology: "Texnologiya",
                    groceries: "Oziq-ovqat mahsulotlari",
                    agriculture: "Qishloq xo‘jaligi mahsulotlari",
                    construction: "Qurilish uchun",
                    pharmaceuticals: "Farmatsevtika",
                    fashion: "Moda sanoati",
                    expensive: "Qimmatbaho yuklar",
                    passenger_cars: "Yengil avtomobillar",
                    liquid_cargo: "Suyuq yuklar",
                    bulk_cargo: "Ommaviy yuklar",
                    heavy_cargo: "Og‘ir yuklar",
                    reefer_cargo: "Muzlatilgan yuklar",
                    carriers_office: "Tashuvchilar ofisi",
                    payments: "To‘lovlar",
                    movement_restrictions: "Harakat cheklovlari",
                    fuel_cards: "Yo‘l yoqilg‘i kartalari",
                    mmsh_offices: "MMSH ofislari",
                    contact_experts: "Mutaxassislar bilan bog‘lanish",
                    business_ethics: "Biznes etikasi",
                    career: "Martaba",
                    vacancies: "Bo‘sh ish o‘rinlari",
                    internship: "Amaliyot"
                },
                business_description: "MMSH Logistics mijozlarimiz va manfaatdor tomonlarning turli ehtiyojlari, umidlari va biznes maqsadlariga moslashishga sodiqdir. Zamonaviy texnologiyalar, soha tajribasi va mijozlarga yo‘naltirilgan yondashuv orqali biz global bozorlarda uzluksiz va samarali logistika operatsiyalarini ta’minlaymiz. Bizning moslashtirilgan yechimlarimiz murakkab ta’minot zanjiri muammolarini hal qiladi, transport tarmoqlarini optimallashtiradi va operatsion samaradorlikni oshiradi.",
  
                certifications: "SERTIFIKATLAR",
                certificate_description: "Ushbu sertifikatlar xalqaro standartlarga muvofiqlikni ta’minlaydi.",
                
                associations: "ASSOTSIATSIYALAR",
                associations_description: "MMSH xalqaro bozorlar uchun samaradorlik va muvofiqlikni ta’minlash maqsadida logistika, savdo va transport sohasidagi yetakchi tashkilotlar bilan hamkorlik qiladi.",
                
                no_certificates: "Sertifikatlar mavjud emas.",
                no_associations: "Assotsiatsiyalar mavjud emas.",
              
                // Certificate List
                certificates_list: [
                  {
                    title: "MMSH ning rasmiy sertifikati",
                    description: "Ushbu sertifikat sifat, xavfsizlik va barqarorlikning yuqori standartlarini kafolatlaydi. Bizning boshqaruv tizimlarimiz xalqaro sifat va ekologik standartlarga mos kelishini tasdiqlaydi.",
                    document: "official"
                  },
                  {
                    title: "GDP - Yaxshi taqsimot amaliyoti",
                    description: "Farmatsevtika mahsulotlarini to‘g‘ri tarqatish va ishlov berishni ta’minlaydi. Ushbu sertifikat transport davomida xavfsizlik va gigiyena standartlariga muvofiqligini tasdiqlaydi.",
                    document: "proof"
                  },
                  {
                    title: "Keng qamrovli yuk sug‘urtasi",
                    description: "Yuklarni tranzit paytida yo‘qolish, shikastlanish yoki o‘g‘irlikdan himoya qiladi. Bizning sug‘urta qamrovimiz xalqaro logistika operatsiyalari uchun moliyaviy xavfsizlik va xavf menejmentini kafolatlaydi.",
                    document: "insurance"
                  },
                  {
                    title: "TAPA - Transport aktivlarini himoya qilish assotsiatsiyasi",
                    description: "Ta’minot zanjirining xavfsizligini va xavf menejmentini ta’minlaydigan sertifikat. Ushbu sertifikat tranzitdagi qimmatbaho tovarlarni o‘g‘irlik va buzilishlardan himoya qilish uchun e’tirof etilgan.",
                    document: "license"
                  },
                  {
                    title: "ATI.SU sertifikati - O‘zbekistonda birinchi bo‘lishimiz uchun",
                    description: "Ushbu sertifikat ta’minot zanjirining xavfsizligi va xavf menejmentini ta’minlaydi. Tranzit davomida qimmatbaho tovarlarni o‘g‘irlik va buzilishlardan himoya qilish uchun e’tirof etilgan.",
                    document: "license"
                  },
                  {
                    title: "ATI.SU sertifikati - O‘zbekistonda eng yaxshi 10 kompaniya ichida bo‘lishimiz uchun",
                    description: "Ushbu sertifikat ta’minot zanjirining xavfsizligi va xavf menejmentini ta’minlaydi. Tranzit davomida qimmatbaho tovarlarni o‘g‘irlik va buzilishlardan himoya qilish uchun e’tirof etilgan.",
                    document: "license"
                  }
                ],
              
                // Association List
                associations_list: [
                  "FPAL - Buyuk Britaniya neft va gaz sanoati tomonidan tashkil etilgan FPAL muvaffaqiyatli shartnoma yetkazib berish va biznes samaradorligini oshirishga yordam beradi.",
                  "EIC - Energy Industries Council (Buyuk Britaniya), global energiya ta’minot zanjirlarini logistika va muvofiqlik nuqtai nazaridan qo‘llab-quvvatlaydi.",
                  "NCBFAA - Amerika bojxona brokerlari va ekspeditorlari assotsiatsiyasi, xalqaro yuk ekspeditsiyasi qoidalariga rioya qilishni ta’minlaydi.",
                  "FIATA - Xalqaro yuk tashish ekspeditorlari federatsiyasi, logistika provayderlarini global miqyosda bog‘laydi.",
                  "AIFFU - Ukraina xalqaro yuk tashish ekspeditorlari assotsiatsiyasi, Sharqiy Yevropada transport aloqalarini mustahkamlaydi.",
                  "ZMPD - Polsha xalqaro avtomobil transporti tashuvchilari assotsiatsiyasi, Yevropa va Xitoy o‘rtasidagi logistika yo‘nalishlarini optimallashtiradi.",
                  "TAPA - Transport aktivlarini himoya qilish assotsiatsiyasi, ta’minot zanjirining xavfsizligi bo‘yicha protokollarni taqdim etadi.",
                  "BVL - Germaniya federal logistika assotsiatsiyasi, Yevropa Ittifoqi bo‘ylab barqaror logistika yechimlarini ilgari suradi.",
                  "TIACA - Xalqaro havo yuk assotsiatsiyasi, dunyo bo‘ylab havo yuk operatsiyalarida ishtirok etuvchi kompaniyalarni birlashtiradi.",
                  "BRITA - Belt and Road xalqaro transport alyansi, Xitoy va Yevropa o‘rtasidagi transport bog‘lanishlarini mustahkamlaydi.",
                  "LANDBRIDGE - Landbridge Logistics Alliance, Yevroosiyo transporti va Xitoy va Yevropa hamkorlari uchun bojxona rasmiylashtirishni qo‘llab-quvvatlaydi."
                ],
              
                // Association Descriptions
                associations_paragraphs: [
                  "MMSH xalqaro savdo samaradorligini ta’minlash uchun yetakchi logistika tashkilotlari bilan faol hamkorlik qiladi.",
                  "Yirik logistika alyanslaridagi a’zolik orqali MMSH xalqaro savdo qoidalari va xavfsizlik standartlariga mos keladigan ta’minot zanjiri yechimlarini kafolatlaydi.",
                  "Xitoyning 'Belt and Road' tashabbusidagi kuchli ishtirokimiz orqali Yevropa hamkorlari uchun yuk tashish yo‘nalishlarini optimallashtiramiz.",
                  "Yevropa logistika federatsiyalari bilan hamkorliklarimiz bizga Yevropa Ittifoqining transport qonunlariga muvofiqlikni saqlashga yordam beradi."
                ],
              
                // Sidebar
                home: "Bosh sahifa",
                orders: "Buyurtmalar",
                messages: "Xabarlar",
                profile: "Profil",
                contacts: "Kontaktlar",
                home_desc: "Bosh sahifaga o‘tish",
                orders_desc: "Yuk buyurtmalarini ko‘rish",
                messages_desc: "Xabarlaringizni tekshirish",
                profile_desc: "Profilingizni ko‘rish",
                contacts_desc: "Kontakt ma’lumotlarini topish",
              
                // Login
                login_title: "Xodim sifatida tizimga kirish",
                username: "Foydalanuvchi nomi",
                password: "Parol",
                login_btn: "Kirish",
                footer_text: "© 2025 MMSH Kompaniyasi",
                error_required: "Foydalanuvchi nomi va parol talab qilinadi",
              
                // Code Verify
                success: "Muvaffaqiyat",
                success_message: "Siz xodim sifatida muvaffaqiyatli ro‘yxatdan o‘tdingiz.",
                return_btn: "Qaytish",
              
                // Wrong
                error: "Xato",
                error_message: "Kechirasiz, siz xodim emassiz.",
                retry_btn: "Qayta urinish",
              
                // Profile
                welcome: "Xush kelibsiz, {{username}}!",
                profile_message: "MMSHda sizni ko‘rib turganimizdan xursandmiz 😇",
                logout: "Chiqish",
              
                // Other Details
                Details: "Tafsilotlar",
                  // Experts
                experts: {
                    john_doe: {
                    name: "Ravshanbek Ahmadjonov",
                    expertise: "Temiryo‘l logistikasi",
                    mission: "Yevropa bo‘ylab yuqori qiymatli yuklarni tashishda ekspert."
                    },
                    jane_smith: {
                    name: "Oyatillo Xamidjanov",
                    expertise: "Yuk tashish va transport",
                    mission: "AQSh va Xitoy o‘rtasidagi savdoni samarali boshqaruvchi yuk tashish bo‘yicha mutaxassis."
                    },
                    michael_lee: {
                    name: "Chirmashev Bekzod",
                    expertise: "Direktor",
                    mission: "Xalqaro savdo munosabatlari bo‘yicha mutaxassis."
                    },
                    sophia_brown: {
                    name: "Oyqiz Mo‘minova",
                    expertise: "Xalqaro yuk tashish",
                    mission: "Xitoydan Yevropaga katta o‘lchamdagi yuklarni tashishda yetakchi ekspert."
                    },
                    liam_garcia: {
                    name: "Guli Adhamjonova",
                    expertise: "Bojxona va muvofiqlik",
                    mission: "Yevropaning qimmatbaho mahsulotlar uchun bojxona qoidalari bo‘yicha ekspert."
                    },
                    olivia_martinez: {
                    name: "Zuhra Qudratillayeva",
                    expertise: "Ombor operatsiyalari",
                    mission: "Amerikadagi yirik tarqatish markazlari uchun ombor avtomatlashtirish bo‘yicha yetakchi strateg."
                    },
                    william_harris: {
                    name: "Kuldashev Bahodirjon",
                    expertise: "Sovuq zanjir logistikasi",
                    mission: "Germaniya bozori uchun farmatsevtika sovuq zanjir logistikasi bo‘yicha mutaxassis."
                    },
                    emma_wilson: {
                    name: "Sardor Husanboyev",
                    expertise: "AQShda oxirgi mil yetkazib berish",
                    mission: "AQSh bo‘ylab tezkor oxirgi mil yetkazib berish bo‘yicha yetakchi ekspert."
                    },
                    ethan_carter: {
                    name: "Abdurahmonov Kamronbek",
                    expertise: "Yevropadagi logistika",
                    mission: "AQSh va Rossiya o‘rtasida chegara osha yuk tashish bo‘yicha tajribali logist."
                    },
                    ava_robinson: {
                    name: "Abbosbek Munavvarov",
                    expertise: "Rossiyadagi logistika",
                    mission: "Yevropa bo‘ylab tezkor yetkazib berish bo‘yicha mutaxassis."
                    },
                    noah_adams: {
                    name: "Ismoilov Asilbek",
                    expertise: "Logistika va ta’minot zanjiri",
                    mission: "Xitoy va Yevropa o‘rtasidagi logistika oqimlarini optimallashtirish bo‘yicha strateg."
                    },
                    isabella_thompson: {
                    name: "Ibrohimjon Mavlonov",
                    expertise: "Yuk tashish va transport",
                    mission: "Xitoydan Germaniyaga interkontinental temiryo‘l yuk tashish bo‘yicha mutaxassis."
                    },
                    lucas_white: {
                    name: "Ulug‘bek Olimov",
                    expertise: "Avtopark boshqaruvi",
                    mission: "AQShda elektr yuk mashinalarini joriy etishga ixtisoslashgan avtopark operatsiyalari eksperti."
                    },
                    mia_johnson: {
                    name: "Farrux Xayitov",
                    expertise: "Xalqaro yuk tashish",
                    mission: "Yevropaning asosiy portlarida yuk tashish kechikishlarini kamaytirish bo‘yicha ekspert."
                    },
                    benjamin_hall: {
                    name: "Zaynobidin Kamoldinov",
                    expertise: "Menejer",
                    mission: "Xitoy-Yevropa savdosi uchun tarif muzokaralari va muvofiqlik bo‘yicha mutaxassis."
                    },
                    ibrohimjon: {
                      name: "Иброхимджон Исаков",
                      expertise: "Развитие менеджмента",
                      mission: "Развитие менеджмента в России, Турции и Европе"
                    },
                    doniyor: {
                      name: "Doniyor Jo'rayev",
                      expertise: "Yuk tashish menejeri",
                      mission: "Rossiya, Belarus va Markaziy Osiyo savdosi bo'yicha menejer"
                    },
                    Hide_Contact: "Kontaktni yashirish",
                    Contact: "Bog‘lanish",
                    Contact_with_Experts: "Mutaxassislar bilan bog‘lanish"
                },
                // Footer
                quick_links: "Tezkor havolalar",
                about: "Haqida",
                contact: "Kontakt",
                news: "Yangiliklar",
                certificates: "Sertifikatlar",
                resources: "Resurslar",
                blog: "Blog",
                careers: "Martaba",
                support: "Qo‘llab-quvvatlash",
                business_ethics: "Biznes etikasi",
                register_as_staff: "Xodim sifatida ro‘yxatdan o‘tish",
                staff_only: "Faqat ro‘yxatdan o‘tgan a’zolar uchun",
                staff: "Xodimlar",
                all_rights_reserved: "Barcha huquqlar himoyalangan.",
                // Footer

                // Cargo Types
                cargo_types: {
                    title: "Yuk turlari",
                    description: "MMSH Logistics turli xil yuklarni xavfsiz, samarali va o‘z vaqtida tashish uchun mukammal xizmatlarni taqdim etadi.",
                    items: [
                    "Ommaviy yuk - Qadoqlanmagan yirik hajmdagi yuklarni samarali tashish.",
                    "Suyuq yuk - Suyuq va kimyoviy moddalarni xavfsiz tashish va boshqarish.",
                    "Muzlatilgan yuk - Tez buziluvchi mahsulotlar uchun harorat nazorat qilinadigan yuk tashish.",
                    "Konteynerli yuk - Standartlashtirilgan konteynerlarda xavfsiz va ishonchli transport.",
                    "Xavfli yuk - Xavfli va tartibga solingan materiallar uchun maxsus logistika xizmatlari.",
                    "Loyiha yuklari - Katta o‘lchamli va murakkab yuklarni tashish uchun moslashtirilgan yechimlar.",
                    "Umumiy yuk - Standart mahsulotlar va tovarlarni ishonchli tashish."
                    ]
                },

                // Header
                header: {
                    Andijon: "Andijon",
                    Alashankou: "Alashankou",
                    Tashkent: "Toshkent"
                },

                // Advantages
                advantages: {
                    title: "BIZNING AFZALLIKLARIMIZ",
                    experience: {
                    title: "Tajriba",
                    description: "MMSH Logistics temiryo‘l transportida 17 yildan ortiq tajribaga ega..."
                    },
                    safety: {
                    title: "Xavfsizlik",
                    description: "Mutaxassislarimiz yuklarning transport davomida butunligini va xavfsizligini ta’minlaydi..."
                    },
                    comprehensiveness: {
                    title: "Kompleks yondashuv",
                    description: "MMSH Logistics yuk tashish xizmatlaridan tashqari omborxona xizmatlarini ham taqdim etadi..."
                    },
                    insurance: {
                    title: "Sug‘urta",
                    description: "MMSH tomonidan tashilgan har bir yuk EUR 3,000,000 gacha sug‘urtalangan..."
                    }
                },

                // Map
                map: "BIZNING GEOGRAFIK QAMROVIMIZ",
                  // Sidebar Products
                submission_failed: "Yuborishda xatolik yuz berdi. Qayta urinib ko‘ring.",
                fill_form_specialist: "Mutaxassis bilan bog‘lanish uchun shaklni to‘ldiring.",
                your_question: "Sizning savolingiz",
                your_name: "Sizning ismingiz",
                your_email: "Sizning email manzilingiz",
                next: "Keyingisi",
                submitting: "Yuborilmoqda...",
                submit: "Yuborish",
                thank_you: "Rahmat! Dispecher tez orada siz bilan bog‘lanadi.",
                logistics_solutions: "Logistika yechimlari",
                trucks: "Yuk mashinalari »",
                trains: "Poyezdlar »",
                ships: "Kemalar »",
                air: "Havo »",
                multimodal: "Multimodal »",
                additional_services: "Qo‘shimcha xizmatlar",
                consulting: "Konsalting »",
                customs_services: "Bojxona xizmatlari »",
                insurance: "Sug‘urta »",
                project_logistics: "Loyiha logistikasi »",
                warehouse_services: "Ombor xizmatlari »",
                // Sidebar Products

                // Request for cargo transportation
                request: "Yuk tashish uchun",
                form: {
                    aboutCompany: "Sizning kompaniyangiz haqida",
                    companyName: "Kompaniya nomi",
                    companyAddress: "Kompaniya manzili",
                    contactInfo: "Kontakt ma’lumotlari",
                    contactName: "Kontakt shaxsning ismi",
                    contactSurname: "Kontakt shaxsning familiyasi",
                    contactPhone: "Kontakt telefon raqami",
                    email: "Email",
                    cargoDetails: "Yuk tafsilotlari",
                    fromCountry: "Qaysi mamlakatdan",
                    toCountry: "Qaysi mamlakatga",
                    cargoType: "Yuk turi",
                    description: "Tavsif",
                    privacyPolicy: "Ushbu shaklni to‘ldirish orqali men maxfiylik siyosatiga rozilik bildiraman.",
                    promotions: "Men MMSH dan email orqali yangiliklar, takliflar va reklama ma’lumotlarini olishga roziman.",
                    send: "Yuborish",
                    sending: "Yuborilmoqda...",
                    success: "Shakl muvaffaqiyatli yuborildi!",
                    error: "Shaklni yuborishda xatolik yuz berdi."
                },
                succes: "Siz yuk tashish uchun muvaffaqiyatli so‘rov yubordingiz. Dispecher tez orada siz bilan bog‘lanadi.",
                // Request for cargo transportation

                // Check cargoes
                loading_cargo: "Yuklanmoqda...",
                errorFetchingCargo: "Yuk so‘rovlarini olishda xatolik yuz berdi.",
                cargoRequests: "Yuk so‘rovlari",
                cargoType: "Yuk turi",
                viewDetails: "Tafsilotlarni ko‘rish",
                // Check cargoes

                // Check cargo details
                cargo_details: "Ushbu yuk so‘rovini o‘chirib tashlashga ishonchingiz komilmi?",
                Cargo_Details: "Yuk tafsilotlari",
                company_name: "Kompaniya nomi",
                company_address: "Kompaniya manzili",
                contact_name: "Kontakt shaxsning ismi",
                contact_phone_detail: "Kontakt telefon raqami",
                email: "Email",
                cargo_type: "Yuk turi",
                description: "Tavsif",
                agree_privacy_policy: "Maxfiylik siyosatiga rozilik",
                agree_promotions: "Reklama takliflariga rozilik",
                save_changes: "O‘zgarishlarni saqlash",
                cancel: "Bekor qilish",
                yes: "Ha",
                no: "Yo‘q",
                delete_cargo: "Yukni o‘chirish",
                edit_cargo_details: "Tahrirlash",
                // Check cargo details

                // Vacancies
                career_opportunities: "MMSH da martaba imkoniyatlari",
                vacancies: "Bo‘sh ish o‘rinlari",
                join_our_team: "Jamoamizga qo‘shiling",
                explore_opportunities: "Biz bilan qiziqarli imkoniyatlarni o‘rganing.",
                search_vacancies: "Bo‘sh ish o‘rinlarini qidiring...",
                vacancy: "Bo‘sh ish o‘rni",
                audience: "Tomoshabin",
                job_category: "Ish turi",
                location: "Joylashuv",
                active: "Faol",
                not_active: "Faol emas",
                no_vacancies: "Bo‘sh ish o‘rinlari topilmadi",
                // Vacancies

                // ChatBot
                ask: "MMSH haqida so‘rang",
                sorry: "Kechirasiz, men buni tushunmadim.",
                // ChatBot

                // About page
                header_title: "Xavfsiz, maqsadli va samarali yuk tashish kompaniyasi.",
                header_description: "MMSH Logistics – xavfsiz va innovatsion transport yechimlarini taqdim etuvchi ishonchli va samarali yuk tashish kompaniyasi.",
                about_company: "Kompaniya haqida",
                read_more: "Batafsil o‘qish",
                read_less: "Kamroq ko‘rsatish",

                quality: "Sifat",
                quality_short: "MMSH Logistics yuqori sifatli, xavfsiz va samarali yuk tashishni kafolatlaydi.",
                quality_full: "MMSH Logistics da sifat nazorati bizning asosiy ustuvor yo‘nalishimizdir. Har bir yukni ehtiyotkorlik bilan qadoqlash va yetkazib berishdan oldin qat’iy monitoring tizimlarini joriy qilamiz.",

                caring_nature: "Ekologik mas’uliyat",
                caring_nature_short: "Biz barcha operatsiyalarimizda barqarorlik va ekologik amaliyotlarni birinchi o‘ringa qo‘yamiz.",
                caring_nature_full: "MMSH Logistics ekologik barqarorlikka katta e’tibor beradi. Biz chiqindilarni kamaytirish va resurslardan samarali foydalanishni ta’minlash orqali ekologik toza logistika tizimini yaratamiz.",

                assistance: "Yordam",
                assistance_short: "Mijozlarimiz uchun eng yaxshi xizmatlar.",
                assistance_full: "MMSH Logistics mijozlarimizga har doim ishonchli yordam ko‘rsatishga intiladi. Bizning mutaxassislarimiz har bir bosqichda muammosiz xizmatni ta’minlash uchun harakat qiladi.",

                innovations: "Innovatsiyalar",
                innovations_short: "Biz yangi g‘oyalarga ochiqmiz.",
                innovations_full: "MMSH Logistics innovatsiyalarni o‘z faoliyatining ajralmas qismi sifatida ko‘radi. Biz samaradorlikni oshirish va ekologik ta’sirni kamaytirish uchun doimiy ravishda yangi texnologiyalarni joriy qilamiz.",

                associations_about: "Assotsiatsiyalar",
                associations_short: "MMSH Logistics global miqyosda tan olingan kompaniyalar bilan hamkorlik qiladi.",
                associations_full: "MMSH Logistics dunyo miqyosidagi mashhur kompaniyalar bilan yaqin hamkorlik qilib, yuqori darajadagi logistika xizmatlarini taqdim etadi.",

                forward_thinking: "Kelajakga qarash",
                forward_thinking_short: "Biz rivojlanish, innovatsiya va global kengayishga e’tibor qaratamiz.",
                forward_thinking_full: "Biz doimiy rivojlanish va xizmatlarimizni yaxshilash ustida ishlaymiz. Kelajakni ko‘zlab, yangi texnologiyalarga sarmoya kiritamiz va operatsiyalarimizni kengaytiramiz.",
                // About page

                // Messages
                fetch_error: "Xabarlarni yuklashda xatolik yuz berdi",
                confirm_delete: "Ushbu xabarni o‘chirishga ishonchingiz komilmi?",
                delete_error: "Xabarni o‘chirishda xatolik yuz berdi",
                delete_error_log: "Xabarni o‘chirishda xatolik:",
                question: "Savol",
                no_messages: "Xabarlar topilmadi.",
                // Messages

                // Contacts
                Search_contacts: "Kontaktlarni qidiring...",
                Contacts: "Kontaktlar",
                Add_Contact: "Kontakt qo‘shish",
                Please: "Iltimos, kontakt ma’lumotlarini ulashmang",
                Save: "Saqlash",
                Username: "Foydalanuvchi nomi",
                Phone_1: "Telefon 1",
                Phone_2: "Telefon 2 (Ixtiyoriy)",
                edit: "Kontaktni tahrirlash",
                delete: "Kontaktni o‘chirish",
            // Contacts         
            // History
            birth_title: "MMSH Logistikasining Yaralishi",
            birth_text: "2019-yilda uch nafar zukko aka-uka – Minhojidin, MuhammadAli va Shukurillo MMSH Logistika kompaniyasiga asos solishdi. Ular global biznesni bog‘lovchi logistika kompaniyasini yaratishni orzu qilishgan.",
            challenges_title: "Qiyinchiliklar va Sabot",
            challenges_text: "Logistika kompaniyasini yaratish oson bo‘lmadi. Ular moliyaviy qiyinchiliklar, operatsion to‘siqlar va raqobatbardosh bozor sharoitida ishonch qozonish muammolari bilan to‘qnash kelishdi. Ammo ularning fidoyiligi va mehnati hech qachon so‘nmadi.",
            expand_title: "Ko‘lamni Kengaytirish",
            expand_text: "Qiyinchiliklarga qaramay, MMSH Logistika tez rivojlandi. Ular strategik hamkorliklarni yo‘lga qo‘ydilar va xizmatlarini doimiy takomillashtirish orqali dunyoning turli burchaklarida biznes olib bora boshladilar.",
            global_title: "Dunyo Bo‘ylab Faoliyat",
            global_text: "Bugungi kunda MMSH Logistika Yevropa, Osiyo va boshqa hududlardagi 34 mamlakat bilan hamkorlik qilmoqda. Ularning global ishtiroki – logistika sohasidagi mukammallikka intilishining natijasidir.",
            career_title: "Yoshlar Uchun Imkoniyatlar",
            career_text: "MMSH Logistika nafaqat transport balki yosh iste’dodlar uchun ham platforma bo‘lib xizmat qiladi. Kompaniya menejment, marketing, IT va ko‘p tilli mutaxassislar uchun yangi imkoniyatlar yaratib kelmoqda.",
            future_title: "MMSH Logistikasining Kelajagi",
            future_text: "Innovatsiya, kuchli yetakchilik va logistika sohasiga bo‘lgan ishtiyoq bilan MMSH Logistika rivojlanishda davom etmoqda. Kelajakda ular global bozorni yanada kengaytirish va zamonaviy texnologiyalarni joriy etishni maqsad qilgan.",
            click_text: "MMSH tarixini bilish uchun kitobga bosing",
            // History
    }
};
export default uz;